import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import SvgIcon from '../Icons/SvgIcon';

var Chevron = function Chevron(props) {
  return _jsx(SvgIcon, __assign({}, props, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.30709 5.75177C8.58228 5.50716 9.00366 5.53195 9.24828 5.80714L12.5816 9.55714C12.8061 9.80973 12.8061 10.1904 12.5816 10.443L9.24828 14.193C9.00366 14.4681 8.58228 14.4929 8.30709 14.2483C8.0319 14.0037 8.00712 13.5823 8.25173 13.3071L11.1914 10L8.25173 6.69296C8.00712 6.41777 8.0319 5.99639 8.30709 5.75177Z"
    })
  }));
};

export default Chevron;